import { Link } from 'react-router-dom';

function SettingsComponent() {
    return (
        <div className="settings-component">
            <Link to="/email-reminder" className="email-me-button">
                Email me when we launch!
            </Link>
        </div>
    );
}

export default SettingsComponent;